import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemLongEditor from '../FormItemLongEditor';
import FormItemLongEditorForDataGrid from '../FormItemLongEditorForDataGrid';
import FormItemLongRender from '../renders/FormItemLongRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';

export default class FormItemLongEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemLongEditorControl";
	}

	validateNotNull()
	{
		if(this.group && this.group.currentRecord)
		{
			var value = this.group.currentRecord[this.getDataField()];
			if(!value || value == "" || value == "0" || value == 0)
			{
				var _label = this.getProperty_Label();
				return _label+" 不能为空";
			}
		}
		return null;
	}

	getProperty_Alignment()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		if(this.properties.hasOwnProperty("Alignment"))
			return this.properties.Alignment;
		return "Right";
	}
	
	getDefaultDisplayLength()
	{
		return 10;
	}

	getProperty_AutoSum() {
		return this.properties.AutoSum;
	}

	getProperty_AllowNegative()
	{
		if(this.properties.hasOwnProperty("AllowNegative"))
			return this.properties.AllowNegative;
		return true;
	}

	getProperty_ShowZero()
	{
		return this.properties.ShowZero;
	}
	getProperty_ThousandSeperator()
	{
		return this.properties.ThousandSeperator;
	}

	getDefaultValue()
	{
		var dvalue = super.getDefaultValue();
		if(dvalue == "")
		{
			dvalue = "0";
		}
		return dvalue;
	}

	getComponentInstance(parent,forLookup)
	{
	  let layout = parent.Properties.Layout.Value;
	  let displayLengthWidth = this.getDisplayLengthWidth();
	  let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
	  let commonProps = this.getCommonProps();
	  let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
	  let displayHeight =this.getProperty_DisplayHeight();
	  let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
	  let _initRecord = this.record;
	  if(!_initRecord)
	  {
		  	if(!this.group)
		  	{
		  		let defaultValue = this.getDefaultValue();
		  		_initRecord = defaultValue;
		  	}
	  }
	  let displayStyle = this.getProperty_DisplayStyle();
      this.component = <FormItemLongEditor displayLengthWidth={displayLengthWidth} key={this.xml.id} 
              displayLength={displayLength} displayHeight={displayHeight} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
              xml={this.xml} parentLayout={layout} forLookup={forLookup} formType={EditorFormType.FormModule} 
              underFieldGroup={parent.type=="FieldGroup"} groupAlias={this.groupAlias}
              dataField = {this.getDataField()} initRecord = {_initRecord}
              label={label} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
              contextMenuData={this.contextMenuData} allowNegative={this.getProperty_AllowNegative()}
              showZero={this.getProperty_ShowZero()} thousandSeperator={this.getProperty_ThousandSeperator()}
			  control={this} underQueryGroup={this.isUnderQueryGroup()} verticalAlign={this.getProperty_VAlignment()} 
			  cssStyle={this.getProperty_CSSStyle_Display()} {...commonProps} displayStyle={displayStyle}/>;
	  return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemLongEditorForDataGrid key={this.xml.id} xml={this.xml} forLookup={forLookup} allowNegative={this.getProperty_AllowNegative()} formType={EditorFormType.FormModule} control={this} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId}
				verticalAlign={this.getProperty_VAlignment()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} group={this.group}/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemLongRender contextMenuData={this.contextMenuData} group={this.group} dataField = {this.getDataField()} showZero={this.getProperty_ShowZero()} thousandSeperator={this.getProperty_ThousandSeperator()}
				verticalAlign={this.getProperty_VAlignment()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemLongRender contextMenuData={this.contextMenuData} group={this.group} dataField = {dataField} showZero={this.getProperty_ShowZero()} thousandSeperator={this.getProperty_ThousandSeperator()}
				verticalAlign={this.getProperty_VAlignment()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={false} moduleInstanceId={this.module.instanceUUId}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
	}

}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemLongEditorControl.js